var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StatelessTags',{attrs:{"value":_vm.tags},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }